import { render, staticRenderFns } from "./InspectSame.vue?vue&type=template&id=89f0f3ee&"
import script from "./InspectSame.vue?vue&type=script&lang=ts&"
export * from "./InspectSame.vue?vue&type=script&lang=ts&"
import style0 from "./InspectSame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports